import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Plus, Star, BookPlus, Timer, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useAuth } from '@/hooks/useAuth';

export function QuickActionFAB() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  // Don't show on auth/onboarding pages
  const hideOnRoutes = ['/auth', '/onboarding', '/onboarding-hub'];
  if (!user || hideOnRoutes.some(route => location.pathname.startsWith(route))) {
    return null;
  }

  const actions = [
    {
      icon: Star,
      label: 'Rate Book',
      onClick: () => {
        navigate('/');
        setIsOpen(false);
      },
      color: 'bg-primary hover:bg-primary/90',
      show: true,
    },
    {
      icon: BookPlus,
      label: 'Add Book',
      onClick: () => {
        navigate('/discover');
        setIsOpen(false);
      },
      color: 'bg-secondary hover:bg-secondary/90',
      show: true,
    },
    {
      icon: Timer,
      label: 'Focus Session',
      onClick: () => {
        navigate('/focus');
        setIsOpen(false);
      },
      color: 'bg-accent hover:bg-accent/90',
      show: true,
    },
  ];

  const visibleActions = actions.filter(action => action.show);

  return (
    <div className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-40 flex flex-col-reverse items-end gap-3">
      {/* Action buttons */}
      {isOpen && visibleActions.map((action, index) => (
        <div
          key={action.label}
          className={cn(
            "flex items-center gap-3 animate-in slide-in-from-bottom fade-in",
            "duration-200"
          )}
          style={{ animationDelay: `${index * 50}ms` }}
        >
          <span className="bg-card text-card-foreground px-3 py-1.5 rounded-lg shadow-lg text-sm font-medium whitespace-nowrap">
            {action.label}
          </span>
          <Button
            size="icon"
            className={cn(
              "h-12 w-12 rounded-full shadow-lg",
              action.color,
              "text-white"
            )}
            onClick={action.onClick}
          >
            <action.icon className="h-5 w-5" />
          </Button>
        </div>
      ))}

      {/* Main FAB */}
      <Button
        size="icon"
        className={cn(
          "h-14 w-14 rounded-full shadow-xl transition-all duration-200",
          "bg-primary hover:bg-primary/90 text-primary-foreground",
          isOpen && "rotate-45"
        )}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? (
          <X className="h-6 w-6" />
        ) : (
          <Plus className="h-6 w-6" />
        )}
      </Button>
    </div>
  );
}
